(function () {
    'use strict';

    angular
        .module('app')
        .service('loginService', loginService);

    loginService.$inject = [
        '$http',
        '$localStorage',
        '$q', '$timeout',
        '$rootScope',
        '$injector',
        '$cookies',
        'authService',
        'clientService',
        'sessionTimeoutService',
        '$interval',
        '$location',
        'systemOptionsService',
        '$state'
    ];

    function loginService(
        $http,
        $localStorage,
        $q, $timeout,
        $rootScope, $injector,
        $cookies,
        authService,
        clientService,
        sessionTimeoutService,
        $interval,
        $location,
        systemOptionsService,
        $state
    ) {
        var service = this;
        service.failedRefresh = false;
        service.refreshing = false;
        service.access_token = "";
        service.refresh_token = "";
        service.acs_token = "";
        service.deferredQueue = [];
        service.acsEnabled = false;
        service.uiVerboseLog = true;
        service.loading = false;
        service.failedRefresh = false;
        service.oAuthEnabled = false;
        service.collabPortalEnabled = false;

        service.log = function (message) {
            if (service.uiVerboseLog) {
                console.log(message);
            }
        }

        //create user info object
        if ($localStorage.userInfo === undefined) {
            $localStorage.userInfo = {};
            
        }
        if ($cookies.userInfo === undefined) {
            $cookies.userInfo = {};
        }

        if ($cookies.get("refreshToken") != "" || $cookies.get("refreshToken") != undefined) {
            service.refresh_token = $cookies.get("refreshToken");
        }   

        // ******************************************
        // Gets the Authentication mode
        // ******************************************
        service.getAuthenticationMode = function () {
            var deferred = $q.defer();

            $http.get('/Synergis.WebApi/Api/AdminOptions/AuthenticationMode').then(function (response) {
                deferred.resolve(response.data);
            }, function () {
                deferred.reject();
            });


            return deferred.promise;
        }

        // ******************************************
        // Guids from Server
        // ******************************************
        service.guid = "";
        service.getGuid = function () {
            $timeout(function () {
                $http.get('/Synergis.WebApi/Api/Configuration/Guid').then(function (response) {
                   service.guid = response.data;
                });
            }, 1000);
            return service.guid;
        }
        service.getGuid(); // Need one ahead of time for CopyURL. Request for 1st will trigger getting the next.

        // ******************************************
        // URL route defined by admin
        // ******************************************
        service.urlRoot = "";
        service.getUrlRoot = function () {
            var deferred = $q.defer();
            if (!service.urlRoot) {
                $http.get('../Synergis.WebApi/api/AdminOptions/GetUrlRoot').then(function (response) {
                    service.urlRoot = response.data;
                    deferred.resolve(response.data);
                });
            }
            else {
                deferred.resolve(service.urlRoot);
            }
            return deferred.promise;
        }



        // ******************************************
        // Information Source: WIP/Library
        // ******************************************

        service.getInformationSource = function () {
            var deferred = $q.defer();
            var request = $http.get('/Synergis.WebApi/Api/Account/InformationSource').then(function (response) {
                service.informationSourceWip = response.data == 1 ? true : false; // It worked, so remember the new state.
                deferred.resolve(response.data);
            }, function (data) {
                deferred.reject(false);
            });
            return deferred.promise;
        }

        // Get a dictionary of available languages for the login dialog.
        // cultureName -> Local Display Name - English Display Name
        // en-US -> English (United States) - English (United States)
        // fr-CA -> francais (Canada) - French (Canada)
        service.setInformationSource = function (informationSourceWip) {

            var informationSource = informationSourceWip ? 1 : 0;
            var deferred = $q.defer();
            var request = $http.get('/Synergis.WebApi/Api/Account/InformationSource/' + informationSource).then(function (response) {
                service.informationSourceWip = informationSourceWip; // It worked, so remember the new state.
                deferred.resolve(response.data);
            }, function (data) {
                deferred.reject(false);
            });
            return deferred.promise;
        }

        // ******************************************
        // URL Navigation
        // ******************************************
        service.urlNavigationFileId = "";
        service.urlNavigationListId = "";

        
        // ******************************************
        // Localization
        // ******************************************

        // currentLanguage - Get and Set
        Object.defineProperty(service, "currentCultureName", {
            get: function () {
                // Default is en-US
                var currentCultureName = $localStorage.userInfo.currentCultureName ? $localStorage.userInfo.currentCultureName : "";
                if (currentCultureName === "" || currentCultureName === undefined) {
                    currentCultureName = $cookies.get('currentCultureName');
                }
                if (currentCultureName === "" || currentCultureName === undefined) {
                    currentCultureName = "en-US";
                }
                return currentCultureName;
            },
            set: function (currentCultureName) {
                $localStorage.userInfo.currentCultureName = currentCultureName;
                $cookies.put('currentCultureName', currentCultureName);
            }
        });

        // Get a dictionary of available languages for the login dialog.
        // cultureName -> Local Display Name - English Display Name
        // en-US -> English (United States) - English (United States)
        // fr-CA -> francais (Canada) - French (Canada)
        service.getAvailableLanguages = function () {
            var deferred = $q.defer();
            var request = $http.get('/Synergis.WebApi/Api/Localization/AvailableLanguages').then(function (response) {
                deferred.resolve(response.data);
            }, function (data) {
                deferred.reject(false);
            });
            return deferred.promise;
        }

        //gets the application version from the server
        service.getAppVersion = function () {
            var deferred = $q.defer();
            var request = $http.get('/Synergis.WebApi/api/configuration/appversion').then(function (response) {
                service.uiVerboseLog = response.data.UIVerboseLog;
                deferred.resolve(response.data.AppVersion);
            }, function (data) {
                deferred.reject(false);
            });
            return deferred.promise;
        }

        service.getAppVersion();

        service.setLongTermKey = function () {

            var deferred = $q.defer();
            $http.get('/Synergis.WebApi/api/account/longtermkey').then(function (response) {
                var secret = response.data["Secret"];
                //Construct logIn object
                var userData = {
                    username: service.loginName,
                    password: "",
                    grant_type: "password",
                    client_id: "LongTermKey",
                    client_secret: secret,
                };

                //Makes http request
                var request = $http({
                    method: 'POST',
                    url: '/Synergis.WebApi/Login',
                    data: userData,
                }).then(function (response) {

                    service.access_token = response.data.access_token;

                    deferred.resolve(response);
                });
            });
            return deferred.promise;

            
        }

        service.removeLongTermToken = function () {
            service.access_token = "null";
        }

        service.getLongTermKey = function () {
            var deferred = $q.defer();
            $http.get('/Synergis.WebApi/api/account/longtermkey').then(function (response) {
                var secret = response.data["Secret"];
                //Construct logIn object
                var userData = {
                    username: service.loginName,
                    password: "",
                    grant_type: "password",
                    client_id: "LongTermKey",
                    client_secret: secret,
                };

                //Makes http request
                var request = $http({
                    method: 'POST',
                    url: '/Synergis.WebApi/Login',
                    data: userData,
                }).then(function (response) {
                    deferred.resolve(response.data.access_token);
                });
            });
            return deferred.promise;
        }

        // Get a dictionary of string table entries.
        // Key -> Value
        // MY_STRING -> My String
        service.resourceStrings = {};
        service.getResourceStrings = function (cultureName) {
            var deferred = $q.defer();
            var request = $http.get('/Synergis.WebApi/Api/Localization/ResourceStrings/' + cultureName).then(function (response) {
                service.currentCultureName = cultureName; // Store here
                service.resourceStrings = response.data; // Store here
                deferred.resolve(response.data);
            }, function (data) {
                deferred.reject(false);
            });
            return deferred.promise;
        }

        service.initStrings = function () {
            if (service.resourceStrings == null || service.resourceStrings["OK"] == null) {
                var currentCultureName = service.currentCultureName;
                return service.getResourceStrings(currentCultureName)
            }
            var deferred = $q.defer();
            deferred.resolve();
            return deferred.promise;
        }

        //service.getResourceString = function (stringId) {
        //    if(service.resourceStrings == null || service.resourceStrings["OK"] == null) {
        //        var currentCultureName = service.currentCultureName;
        //        service.getResourceStrings(currentCultureName);
        //    }
        //    return service.resourceStrings[stringId];
        //}

        ////////////////////////////////////////////////////////////////////
        //////////////////////////LogIn method//////////////////////////////
        ////////////////////////////////////////////////////////////////////
        //JM 3/1/2016 added a parameter to force login in case the user is already logged in.
        service.logIn = function (credentials, force, cultureName) {
            //reset the ACS update notified flag.
            clientService.updateNotified = false;
            clientService.needsUpdate = false;

            var offset = new Date().getTimezoneOffset();
            // js is backwards
            if (offset > 0)
                offset = 0 - offset;
            service.log('offset in minutes: ' + offset);
            service.log('offset in hours: ' + offset / 60);

            //if autologin is not allowed, force autologin off 
            if (!service.allowAutoLogin) {
                $localStorage.userInfo.autoLogin = false;
            }
            //Construct logIn object
            var userData = {
                username: credentials.loginName,
                password: credentials.loginPassword,
                cultureName: cultureName,
                grant_type: "password",
                client_id: "Adept",
                forceLogin: force,
                connectionId: $rootScope.loginHub.connectionId,
                autoLogin: $localStorage.userInfo.autoLogin,
                timeZoneOffset: offset,
                windowsLogin: credentials.windowsLogin,
                windowsDomain: credentials.windowsDomain
            };

            var deferred = $q.defer();

            //Makes http request
            var request = $http({
                method: 'POST',
                url: '/Synergis.WebApi/Login',
                data: userData,
            }).then(function (response, status, headers, cfg) {
                var decodedString = atob(response.data.refresh_token);

                // ***************************************************************************
                // BEGIN: Session Timeouts
                // ***************************************************************************
                
                // Get session timeout info from login result.
                var enableSessionTimeOut = response.data.enableSessionTimeOut == 'True';
                var enableSessionTimeOutDebugging = response.data.enableSessionTimeOutDebugging == 'True';
                var sessionTimeOutMinutes = Number(response.data.sessionTimeOutMinutes);
                // Startup
                sessionTimeoutService.onLogin(enableSessionTimeOut, enableSessionTimeOutDebugging, sessionTimeOutMinutes);

                // ***************************************************************************
                // END: Session Timeouts
                // ***************************************************************************

                var dateForRefreshToExpire = 0;
                if ($localStorage.userInfo.autoLogin) {
                    dateForRefreshToExpire = new Date();
                    dateForRefreshToExpire.setDate(dateForRefreshToExpire.getDate() + 30);
                }

                $cookies.put("refreshToken", decodedString, { expires: dateForRefreshToExpire });
                service.refresh_token = decodedString;
                service.access_token = response.data.access_token;
            
                service.initializeSession().then(function (data) {
                    
                    deferred.resolve(data);
                });
                

            }, function (err, status) {
                deferred.reject(err);
            });

            return deferred.promise;
        };

        service.logInSSO = function (auth_code) {
            //reset the ACS update notified flag.
            clientService.updateNotified = false;
            clientService.needsUpdate = false;

            var offset = new Date().getTimezoneOffset();
            // js is backwards
            if (offset > 0)
                offset = 0 - offset;
            service.log('offset in minutes: ' + offset);
            service.log('offset in hours: ' + offset / 60);

            //if autologin is not allowed, force autologin off 
            if (!service.allowAutoLogin) {
                $localStorage.userInfo.autoLogin = false;
            }
            //Construct logIn object
            var userData = {
                username: 'SSO',
                password: '',
                cultureName: 'en-US',
                grant_type: "password",
                client_id: "Adept",
                forceLogin: true,
                connectionId: $rootScope.loginHub.connectionId,
                autoLogin: false,
                timeZoneOffset: offset,
                auth_code: auth_code,
            };

            var deferred = $q.defer();

            //Makes http request
            var request = $http({
                method: 'POST',
                url: '/Synergis.WebApi/Login',
                data: userData,
            }).then(function (response, status, headers, cfg) {
                var decodedString = atob(response.data.refresh_token);
                $localStorage.lastGoodToken = decodedString;
                // ***************************************************************************
                // BEGIN: Session Timeouts
                // ***************************************************************************

                // Get session timeout info from login result.
                var enableSessionTimeOut = response.data.enableSessionTimeOut == 'True';
                var enableSessionTimeOutDebugging = response.data.enableSessionTimeOutDebugging == 'True';
                var sessionTimeOutMinutes = Number(response.data.sessionTimeOutMinutes);
                // Startup
                sessionTimeoutService.onLogin(enableSessionTimeOut, enableSessionTimeOutDebugging, sessionTimeOutMinutes);

                // ***************************************************************************
                // END: Session Timeouts
                // ***************************************************************************

                $cookies.put("refreshToken", decodedString);
                service.refresh_token = decodedString;
                service.access_token = response.data.access_token;

                service.initializeSession().then(function (data) {

                    deferred.resolve(data);
                });


            }, function (err, status) {
                deferred.reject(err);
            });

            return deferred.promise;
        };


        ////////////////////////////////////////////////////////////////////
        //////////////////////////LogIn to ACS method//////////////////////////////
        ////////////////////////////////////////////////////////////////////
        service.logInACS = function (url, credentials, force, cultureName) {
            //Construct logIn object
            var userData = {
                grant_type: "password",
                webapiurl: window.location.origin + "/synergis.webapi/",
                webapitoken: service.access_token,
                username: service.userName,
                culture: service.currentCultureName //Bill 01-23-2018 Send ACS the callers chosen adept culture
            };

            service.log(userData);

            var deferred = $q.defer();

            //Makes http request
            var request = $http({
                method: 'POST',
                url: url + '/token',
                data: userData,
            }).then(function (response, status, headers, cfg) {
                service.acs_token = response.data.access_token;
                service.acsEnabled = true;
                deferred.resolve();
            }, function (err, status) {
                service.acsEnabled = false;
                service.log(err);
                if (err.data) {
                    if (err.data.error == "invalid_grant") {
                        service.isLoggedIn().then(function () {
                            err.config.data.webapitoken = service.access_token;
                            $injector.get('$http')(err.config).then(function (response) {
                                service.acs_token = response.data.access_token;
                                deferred.resolve();
                            }, function (err, status, header, cfg) {
                                service.log(err);
                                deferred.reject(err);
                            })
                        }, function (err) {
                            service.log(err);
                            deferred.reject(err);
                        });
                    }
                }
                
            });

            return deferred.promise;
        };

        service.checkACSStatus = function () {
            var deferred = $q.defer();
            $http.get('http://localhost:4040/api/status?id=' + $localStorage.acsId).then(function () {
                deferred.resolve();
            }, function () {
                deferred.reject();
            });
            return deferred.promise;
        }

        function PublishWave() {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/PublishWave/ValidateServerLicenses').then(function (response) {
                if (response.data != null) {
                    var SubscriptionModelList = response.data;

                    var SubscriptionStatus = {
                        NoError: 0,
                        Failure: 1,
                        Expiring: 2,
                        Expired: 3
                    };

                    var msg = "";
                    var msgType = 2; // warning
                    // Only things that need to be shown will be in the list.
                    angular.forEach(SubscriptionModelList, function (SubscriptionModel) {
                        msg = msg + SubscriptionModel.Name + "\t: \t" + SubscriptionModel.Message + "\n";
                        if (SubscriptionModel.Status == SubscriptionStatus.Failure || SubscriptionModel.Status == SubscriptionStatus.Expired)
                            msgType = 3; // error
                    });
                    if (msg.length > 0) {
                        $timeout(function () {
                            var title = "PublishWave"; // Product Name with no space and not localized.
                            var bNoIndent = true;
                            $rootScope.msgBoxShow(msg, title, msgType, bNoIndent);
                        }, 1000);
                    }
                }
                deferred.resolve();
            }, function () {
                deferred.reject();
            });
            return deferred.promise;
        }

        //method to initialize settings required for the application
        service.initializeSession = function () {
            var deferred = $q.defer();
            $http.get('../Synergis.WebApi/api/account/userinfo').then(function (response) {
                var userInfo = response.data;
                service.id = response.data.Id;
                service.userName = response.data.UserName;
                service.loginName = response.data.LoginName
                service.isAdmin = response.data.IsAdmin;
                service.loggedIn = true;
                service.reviewer = response.data.Reviewer;
                service.creator = response.data.Creator;
                service.explorer = !service.reviewer && !service.creator;
                service.failedRefresh = false;
                service.domain = response.data.Domain;

                //clear data from singletons
                var searchService = $injector.get('searchService');
                searchService.close();
                searchService.getDateFormat();
                var columnFactory = $injector.get('columnFactory');
                columnFactory.close();
                var libraryService = $injector.get('libraryService');
                libraryService.close();
                // Update at login if system options change
                var systemOptionsService = $injector.get('systemOptionsService');
                systemOptionsService.getShowExtraCommands();
                systemOptionsService.getEnableUpload();
                systemOptionsService.getAllowDownload();
                systemOptionsService.getLocalViewerSettings();
                systemOptionsService.getStartUpOptions().then(function () {

                    if (service.creator)
                        PublishWave();

                    service.loggedIn = true;
                    service.failedRefresh = false;

                    //if the user is creator, we will check the status of ACS
                    if (service.creator && $state.current.name != "viewpdf") {
                        console.log("checking acs from loginService");
                        clientService.get("status?id=" + $localStorage.acsId).then(function (result) {
                            console.log("")
                        });
                    }

                    if (!$localStorage.selectedWorkAreas) {
                        $localStorage.selectedWorkAreas = {};
                        $localStorage.selectedWorkAreas[response.data.Id] = null;
                    }

                    service.collabPortalEnabled = service.isCollabPortalEnabled();
                    deferred.resolve(userInfo);
                });
            });

            return deferred.promise;
        }

        //service.checkLoginPageAllowed = function () {
        //    var deferred = $q.defer();
        //    service.loading = true;
        //    //check if the user is logged in
        //    service.isLoggedIn().then(function () {
        //        //if the user is logged in, the logging page is not allowed, reject
        //        service.loading = false;
        //        deferred.reject();
        //    }, function () {
        //        console.log("user is not logged in");
        //        service.loading = false;
        //        deferred.resolve();
        //        //if the user is not logged in, first check if oauth is enabled
        //        service.checkOauthEnabled().then(function (answer) {
        //            if (answer) {
        //                console.log('oauth is enabled');
        //                service.checkForOAuth().then(function () {
        //                    //everything checks out, reject and go home
        //                    service.loading = false;
        //                    deferred.reject();
        //                    $state.go('layout.home');
        //                }, function () {
        //                    //there was a problem validating
        //                    service.loading = false;
        //                    deferred.reject('oauth_fail');
        //                    $state.go('oauth_fail');
        //                });
        //            }
        //            else {
        //                //oauth is not enabled, resolve so the login page can be displayed.
        //                deferred.resolve();
        //            }
        //            service.loading = false;
        //        });

        //    });
        //    return deferred.promise;
        //}

        service.checkOauthEnabled = function () {
            var deferred = $q.defer();
            $http.get('/Synergis.WebApi/api/adminoptions/IsOAuthEnabled').then(function (resp) {
                service.oAuthEnabled = resp.data;
                deferred.resolve(resp.data);
            });
            return deferred.promise;
        }

        service.isCollabPortalEnabled = function() {
            //var deferred = $q.defer();
            //$http.get('/Synergis.WebApi/api/adminoptions/CollabPortalEnabled').then(function (resp) {
            //    service.collabPortalEnabled = resp.data;
            //    deferred.resolve(resp.data);
            //});
            //return deferred.promise;
            var enabled = systemOptionsService.startUpOptions['CollabPortalEnabled'] ? systemOptionsService.startUpOptions['CollabPortalEnabled'] : false;
            return enabled;
        }

        service.redirectToOAuth = function () {
            var deferred = $q.defer();
            $localStorage.userInfo = {};
            $http.get('/Synergis.WebApi/api/adminoptions/OAuthSettings').then(function (resp) {
                console.log(resp.data);
                var authURL = resp.data["AuthorizationURL"];
                var clientId = resp.data["ClientId"];
                var oauthScope = resp.data["Scope"] ? resp.data["Scope"] : "openid";
                var additionalParams = resp.data["OAuthAdditionalLoginParams"];
                if (additionalParams) {
                    additionalParams = additionalParams.split(';');
                }

                if (!authURL || !clientId) {
                    deferred.reject();
                }
                else {
                    authURL = authURL + "?client_id=" + clientId + "&scope=" + oauthScope + "&response_type=code&state=state-296bc9a0-a2a2-4a57-be1a-d0e2fd9bb601";
                    
                    angular.forEach(additionalParams, function (item) {
                        authURL = authURL + "&" + item;
                    });

                    var urlParams = $rootScope.routeParams;

                    var redirect = window.location.origin.toLowerCase() + '/synergis.webapp/oauth_callback.html';

                    sessionStorage.setItem("routeParams", JSON.stringify(urlParams));

                    authURL = authURL + "&redirect_uri=" + redirect; 
                    window.location.href = authURL;
                }
                    
            }, function (error) {
                deferred.reject(error);
            });
                
            
            return deferred.promise;
        }



        //Important for error handling
        service.logIn.description = "login";

        service.refreshToken = function () {
            //alert("refreshing token");
            service.refreshing = true;
            var deferred = $q.defer();
            var userInfo = $localStorage.userInfo;

            service.refresh_token = $cookies.get("refreshToken");
            if (userInfo) {

                isHubConnected().then(function () {
                    var userData = {
                        grant_type: "refresh_token",
                        refresh_token: service.refresh_token,
                        client_id: "Adept",
                        connectionId: $rootScope.loginHub.connectionId
                    };

                    var data = "loginName=" + service.loginName + "&" + "grant_type=refresh_token&refresh_token=" + service.refresh_token + "&client_id=Adept" + "&connectionId=" + $rootScope.loginHub.connectionId + "&autoLogin=" + $localStorage.userInfo.autoLogin;
                    service.log(new Date(), "About to refresh token: " + service.refresh_token);
                    $http = $http || $injector.get('$http');
                    console.log("attempting to refresh token - token:", service.refresh_token);
                    $http.post('/Synergis.WebApi/Login', data, { headers: { 'Content-Type': 'application/x-www-form-urlencoded', 'Connection-Id': $rootScope.loginHub.connectionId } }).then(function (response) {
                        var decodedString = atob(response.data.refresh_token);
                        console.log("refreshed token successfully");
                        console.log("new token: ", decodedString);
                        $localStorage.lastGoodToken = decodedString;

                        var dateForRefreshToExpire = 0;
                        if ($localStorage.userInfo.autoLogin) {
                            dateForRefreshToExpire = new Date();
                            dateForRefreshToExpire.setDate(dateForRefreshToExpire.getDate() + 30);
                        }

                        $cookies.put("refreshToken", decodedString, { expires: dateForRefreshToExpire });

                        service.refresh_token = decodedString;
                        service.access_token = response.data.access_token;
                        if (bowser.msie) {
                            $localStorage.ieRefreshToken = decodedString;
                        }

                        service.refreshing = false;
                        deferred.resolve(response);
                    }, function (response) {
                        service.log(response);
                        service.log(new Date(), 'failed to refresh token Id: ' + service.refresh_token);
                        authService.loginCancelled("", "");
                        deferred.reject(response);
                    });
                });
                
            } else {
                deferred.reject();
            }

            return deferred.promise;
        };

        function isHubConnected() {
            var deferred = $q.defer();
            deferred.resolve($rootScope.loginHub.connected);
            //var timer = $interval(function () {
            //    if ($rootScope.loginHub.connected)
            //        $interval.cancel(timer);
            //    else {
            //        //console.log("signal-r not connected yet");
            //        $rootScope.loginHub.start({
            //            userId: $localStorage.userInfo.id,
            //            clientId: "Adept",
            //            autoLogin: $localStorage.userInfo.autoLogin,
            //            loginName: $localStorage.userInfo.loginName,
            //            userName: $localStorage.userInfo.userName
            //        });
            //    }
                    
            //}, 1000, 15);

            //timer.then(function () {
            //    //console.log("interval done");
            //    deferred.reject();
            //}, function() {
            //    //console.log("interval canceled");
            //    deferred.resolve();
            //});

            return deferred.promise;
        }

        service.refreshToken.description = "refreshtoken";

        ////////////////////////////////////////////////////////////////////
        //////////////////////////LogOut method//////////////////////////////
        ////////////////////////////////////////////////////////////////////
        service.logOut = function () {

            // If open, will send a signal to release any redline locks and close the window frame - not exit the app
            var port = window.location.protocol === "http:" ? "3922" : "3923";
            var viewerUrl = window.location.protocol + "//localhost:" + port + "/closefile";

            $http.get(viewerUrl).then(function (response) {
                service.log("close viewer window failed.");
            });

            // ***************************************************************************
            // BEGIN: Session Timeouts
            // ***************************************************************************
            
            sessionTimeoutService.onLogout();
            
            // ***************************************************************************
            // END: Session Timeouts
            // ***************************************************************************

            //trigger a transition
            
            
            var webApiUrl = '/Synergis.WebApi/Api/Account/Logout/' + $rootScope.loginHub.connectionId;

            service.log("********** Calling Logout at " + webApiUrl);

            var request = $http.get(webApiUrl).then(function (response) {
                service.access_token = "";
                service.refresh_token = "";
                $localStorage.viewerOptions = {};
                $localStorage.userSettings.searchCriteria = [];
                service.log("log out success");
                service.clearData();
                clientService.disconnect();
                $cookies.put("refreshToken", "");
                $localStorage.refreshToken = "";
                service.refresh_token = "";
                service.access_token = "";
                clientService.success = false;
                if (bowser.msie) {
                    $localStorage.ieRefreshToken = "";
                }

            }, function (error) {
                service.log("log out failed.");
            });

            return request;
        };

        //Important for error handling
        service.logOut.description = "logOut";

        service.clearData = function () {
            service.access_token = "";
            
            //clear data from singletons
            var searchService = $injector.get('searchService');
            searchService.close();
            var columnFactory = $injector.get('columnFactory');
            columnFactory.close();

            var dataCardService = $injector.get('dataCardService');
            dataCardService.close();

            var favoritesService = $injector.get('favoritesService');
            favoritesService.close();

            var savedSearchService = $injector.get('savedSearchService');
            savedSearchService.close();

            var libraryService = $injector.get('libraryService');
            libraryService.close();

            var gridDataService = $injector.get('gridDataService');
            gridDataService.close();

            var ddService = $injector.get('ddService');
            ddService.close();

            // 2016-10-04
            var columnSetService = $injector.get('columnSetService');
            columnSetService.close();

            // 
            var workAreaService = $injector.get('workAreaService');
            workAreaService.close();

            var clientService = $injector.get('clientService');
            clientService.close();
            clientService.connected = false;
            service.acs_token = "";

            var sidebarService = $injector.get('sidebarservice');
            sidebarService.fileGuideCollapse = true;
            sidebarService.showDataToolBox = false;
            sidebarService.leftSideBarCollapse = false; // Logout and re-login menus not showing correctly.
            //sidebarService.leftSideBarOpen = true; // Logout and re-login menus not showing correctly.
            sidebarService.rightSideBarOpen = false; // close right sidebar on logout.
        }

        //this will be called when the service is instantiated to set the allow auto login option
        var allowAutoLoginUrl = '/Synergis.WebApi/Api/adminoptions/allowautologin'
        var request = $http.get(allowAutoLoginUrl);
        request.then(function (response) {
            service.allowAutoLogin = response.data;
        });

        //method to check if the user is logged in
        service.isLoggedIn = function () {
            //alert("isLoggedIn Called");
            var deferred = $q.defer();
            service.deferredQueue.push(deferred);

            if (!service.checkingIsLoggedIn) {
                service.checkingIsLoggedIn = true;
                var request = $http.get('/Synergis.WebApi/Api/Account/isloggedin').then(function (response) {

                    if (!$localStorage.userInfo || !$localStorage.userInfo.id) {

                        service.initializeSession().then(function () {
                            service.checkingIsLoggedIn = false;
                            service.deferredQueue.forEach(function (d) {
                                //alert("isLoggedIn True");
                                d.resolve(response.data);
                            });
                        });
                        
                    }
                    else {
                        service.checkingIsLoggedIn = false;
                        service.deferredQueue.forEach(function (d) {
                            //alert("isLoggedIn True");
                            d.resolve(response.data);
                        });
                    }
               
                }, function (data) {
                    //alert("isLoggedIn Failed");
                    service.checkingIsLoggedIn = false;
                    service.deferredQueue.forEach(function (d) {
                        d.reject(false);
                    });
                    service.deferredQueue = [];
                });
            }           
            return deferred.promise;
        };

        service.isLoggedIn.description = "isLoggedIn";

        Object.defineProperty(service, "autoLogin", {
            get: function () {
                var autoLogin = $localStorage.userInfo.autoLogin;
                if (autoLogin === "" || autoLogin === undefined) {
                    autoLogin = $cookies.get('autoLogin');
                }
                return autoLogin;
            },
            set: function (autoLogin) {
                $localStorage.userInfo.autoLogin = autoLogin;
                $cookies.put('autoLogin', autoLogin);
            }
        });

        Object.defineProperty(service, "id", {
            get: function () {
                var id = $localStorage.userInfo.id;
                if (id === "" || id === undefined) {
                    id = $cookies.get('id');
                }
                return id;
            },
            set: function (id) {
                $localStorage.userInfo.id = id;
                $cookies.put('id', id);
            }
        });

        Object.defineProperty(service, "loginName", {
            get: function () {
                var loginName = $localStorage.userInfo.loginName;
                if (loginName === "" || loginName === undefined) {
                    loginName = $cookies.get('loginName');
                }
                return loginName;
            },
            set: function (loginName) {
                $localStorage.userInfo.loginName = loginName;
                $cookies.put('loginName', loginName);
            }
        });

        Object.defineProperty(service, "userName", {
            get: function () {
                var userName = $localStorage.userInfo.userName;
                if (userName === "" || userName === undefined) {
                    userName = $cookies.get('userName');
                }
                return userName;
            },
            set: function (userName) {
                $localStorage.userInfo.userName = userName;
                $cookies.put('userName', userName);
            }
        });

        Object.defineProperty(service, "isAdmin", {
            get: function () {
                var isAdmin = $localStorage.userInfo.isAdmin;
                if (isAdmin === "" || isAdmin === undefined) {
                    isAdmin = $cookies.get('isAdmin');
                }
                return isAdmin;
            },
            set: function (isAdmin) {
                $localStorage.userInfo.isAdmin = isAdmin;
                $cookies.put('isAdmin', isAdmin);
            }
        });

        Object.defineProperty(service, "loggedIn", {
            get: function () {
                var loggedIn = $localStorage.userInfo.loggedIn ? $localStorage.userInfo.loggedIn : false ;
                if (loggedIn === "" || loggedIn === undefined) {
                    loggedIn = $cookies.get('loggedIn');
                }
                return loggedIn;
            },
            set: function (loggedIn) {
                $localStorage.userInfo.loggedIn = loggedIn;
                $cookies.put('loggedIn', loggedIn);
            }
        });

        Object.defineProperty(service, "reviewer", {
            get: function () {
                var reviewer = $localStorage.userInfo.reviewer;
                if (reviewer === "" || reviewer === undefined) {
                    reviewer = $cookies.get('reviewer');
                }
                return reviewer;
            },
            set: function (reviewer) {
                $localStorage.userInfo.reviewer = reviewer;
                $cookies.put('reviewer', reviewer);
            }
        });

        Object.defineProperty(service, "explorer", {
            get: function () {
                var explorer = $localStorage.userInfo.explorer;
                if (explorer === "" || explorer === undefined) {
                    explorer = $cookies.get('explorer');
                }
                return explorer;
            },
            set: function (explorer) {
                $localStorage.userInfo.explorer = explorer;
                $cookies.put('explorer', explorer);
            }
        });

        Object.defineProperty(service, "creator", {
            get: function () {
                var creator = $localStorage.userInfo.creator;
                if (creator === "" || creator === undefined) {
                    creator = $cookies.get('creator');
                }
                return creator;
            },
            set: function (creator) {
                $localStorage.userInfo.creator = creator;
                $cookies.put('creator', creator);
            }
        });


        Object.defineProperty(service, "domain", {
            get: function () {
                var domain = $localStorage.userInfo.domain;
                if (domain === "" || domain === undefined) {
                    domain = $cookies.get('domain');
                }
                return domain;
            },
            set: function (domain) {
                $localStorage.userInfo.domain = domain;
                $cookies.put('domain', domain);
            }
        });


        var oauthpopup = function (options) {
            options.windowName = options.windowName || 'ConnectWithOAuth'; // should not include space for IE
            options.windowOptions = options.windowOptions || 'location=0,status=0,width=800,height=400';
            options.callback = options.callback || function () { window.location.reload(); };
            var that = this;
            //log(options.path);
            that._oauthWindow = window.open(options.path, options.windowName, options.windowOptions);
            that._oauthInterval = window.setInterval(function () {
                if (that._oauthWindow.closed) {
                    window.clearInterval(that._oauthInterval);
                    options.callback();
                }
            }, 1000);
        };


    }

    //generates a guid
    function uuidv4() {
        return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
            var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
            return v.toString(16);
        })
    }

})();